import { useSuspenseQuery } from '@tanstack/react-query'

import { GetLotesEmpreendimentoService } from '@/features/empreendimentos/http'
import { produtosKeys } from '@/utils/produtos-query-keys'

export const useSuspenseLotesEmpreendimento = (idExternoEmpreendimento: string) => {
  return useSuspenseQuery({
    queryKey: produtosKeys.lotesEmpreendimento(idExternoEmpreendimento),
    queryFn: () =>
      new GetLotesEmpreendimentoService().execute(idExternoEmpreendimento).then((response) => response.data),
  })
}
